/*
 *###############################################################################
 *Module Name                   : VoucherGroupControl.js                        #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Monday, September 27th 2021, 1:19:48 pm       #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */
import React, { useState, useEffect } from "react"
import { MetaTags } from "react-meta-tags"
import { Card, Col, Container, Row, CardBody } from "reactstrap"

//**Importing required componant files   */
import Breadcrumb from "components/Common/Breadcrumb"
import DPTopToolBar from "framework/widgets/DPTopToolBar"
import VoucherGroupContent from "./VoucherGroupContent"
import DPInfoBox from "framework/layout/DPInfoBox"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import {
  setVoucherGroupSave,
  getVoucherGroupSearch,
} from "./VoucherGroupControl"
import DPLoadingAlert from "framework/widgets/DPLoadingAlert"
import DPPermission from "framework/widgets/DPPermission"
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from "react"
//**End Importing required componant files */

const VoucherGroup = props => {

  let history = useHistory();
  const {
    getMenuDetails, masterAuditLog, addtoFavourite
  } = useContext(Context);
  //*** User input related states */
  const [strVoucherCode, SetCode] = useState("") // Set Code
  const [strVoucherDesc, SetDescription] = useState("") //Set Description
  const [IsActive, SetActive] = useState(true) //Set Active state
  const [dbSellValue, SetSellValue] = useState("0.0")
  const [dbValidDaysValue, SetValidDaysValue] = useState("1")
  const [dbPrintCostValue, SetPrintCostValue] = useState("0.0")
  const [dbNumberOfVouchersValue, SetNumberOfVouchersValue] = useState("1")
  const [dbBookNumberValue, SetBookNumberValue] = useState(0)
  const [blEditableStatus, SetEditableStatus] = useState(false)
  const [blRandomStatus, SetRandomStatus] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [strReason, setReason] = useState("Created")
  const [AddNew, setAddNew] = useState(true)
  const [deleteEnable, SetDeleteEnable] = useState(false)
  const [disabled, setDisabled] = useState(false)

  //*** End User input related states */

  //*** User Activity related states*/
  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [AlertShow, setAlertShow] = useState(false)
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [disabledDesc, setDisabledDesc] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [disabledSelling, setDisabledSelling] = useState(false)
  const [disabledCost, setDisabledCost] = useState(false)
  const [disabledValidDays, setDisabledValidDays] = useState(false)
  const [disabledVoucherBook, setDisabledVoucherBook] = useState(false)
  const [disabledBookNo, setDisabledBookNo] = useState(false)
  const [disabledActive, setDisabledActive] = useState(false)
  const [disabledEditable, setDisabledEditable] = useState(false)
  const [disabledRandomNo, setDisabledRandomNo] = useState(false)
  const [menuCode, SetMenuCode] = useState("")
  //*** End User activity related staes */

  //*** useState to save table data */
  const [DataTables, SetDatatable] = useState([])
  //*** End of useStates */

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")

  //*****Menu Rights End */

  //autocode generation related newly added code
  const [codeButton, setCodeButton] = useState(true)
  const [searchdisabled, setSearchdisabled] = useState(false)
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)

  const [helpUrl, setHelpUrl] = useState("")
  var time = process.env.REACT_APP_ALERTTIMEOUT


  //**Get File Details */
  useEffect(async () => {
    const authToken = localStorage.getItem("authToken")
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)
    const ApiURL = window.Links.ApiURL


    var requestOptions = {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetMenuAccess(result.data.strMenuAccessRight)
        SetMenuCreate(result.data.strMenuCreateRight)
        SetMenuDelete(result.data.strMenuDeleteRight)
        SetMenuModify(result.data.strMenuModifyRight)
        SetMenuPrint(result.data.strMenuPrintRight)
        SetMenuProcess(result.data.strMenuProcessRight)
        SetMenuName(result.data.strMenuName)
        SetMenuCode(result.data.strMenuTag)
        setPermissionReasonShow(result.data.strMenuReasonShow)
        setHelpUrl(result.data.strHelpUrl)

        fetch(`${ApiURL}common/autocode/${result.data.strMenuTag}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`
          },
        }).then(Response => Response.json())
          .then(responseData => {
            console.log(responseData)
            if (responseData.success == true) {
              if (responseData.data.length == 0) {
                setNullCode(true)
              } else {
                console.log(responseData.data)
                setAutoCode(responseData.data)
              }
            }
          })


      }).catch(error =>
        console.log('error', error)
      );


  }, [strVoucherCode])



  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])



  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  const setIntFromBool = blParameter => {
    if (blParameter) {
      return 1
    } else {
      return 0
    }
  }
  //save button function
  const handlesave = async () => {

    if (AddNew == true && nullCode == false) {
      SetCode(autoCode)
    }

    var code = AddNew == true && nullCode == false ? autoCode : strVoucherCode;

    if (code == "") {
      displayAlertMessage('danger', "Please Enter Voucher Group Code !")
      return
    }

    if (strVoucherDesc == "") {
      displayAlertMessage('danger', "Please Enter Voucher description")
      return
    }
    if (blRandomStatus == false) {
      if (dbSellValue <= 0) {
        displayAlertMessage('danger', "Sales value must be greater than zero")
        return
      }

    }

    SetLoadingAlert(true)
    if (AddNew == true) {
      SetLoadingAlerttitle("Saving...")
    } else {
      SetLoadingAlerttitle("Updating...")
    }

    let strResult = await setVoucherGroupSave(
      code,
      strVoucherDesc,
      parseFloat(dbSellValue),
      parseFloat(dbValidDaysValue),
      parseFloat(dbPrintCostValue),
      parseFloat(dbNumberOfVouchersValue),
      dbBookNumberValue,
      IsActive,
      setIntFromBool(blEditableStatus),
      setIntFromBool(blRandomStatus),
      LogUserType,
      menuCode,
      LogCompanyCode,
      LocationCode,
      strReason,
      AddNew
    )

    if (strResult.status == "200") {
      SetLoadingAlert(false)
      strResult.json().then(responseData => {
        if (responseData.data == "Record Already Exsist!") {
          displayAlertMessage('danger', responseData.data)

        } else if (responseData.data == "Code Already Exsist!") {
          displayAlertMessage('danger', responseData.data)
          setCodeButton(false)

        } else {
          handleNew()
          displayAlertMessage('success', responseData.data)

        }
      })
    } else if (strResult.status == "400") {
      SetLoadingAlert(false)
      strResult.json().then(responseData => {
        setAlertMsg(responseData.msg)
      })
      setAlertColor("danger")
      setAlertShow(true)
    } else {
      SetLoadingAlert(false)
      handleNew()
    }
    setTimeout(() => {
      setAlertShow(false)
    }, 4000)
  }


  //*** Get user selected row details */
  const GetSelectRow = (e, row, isSelect, rowIndex) => {
    SetCode(row.VCG_CODE)
    ValueSetter(row.VCG_CODE)
    setmodal_xlarge(!modal_xlarge)
  }
  //*** End of getSelectedRow function */

  //edit button function
  const handleEdit = e => {
    setDisabledCode(true)
    setDisabledBookNo(true)
    setDisabledDesc(false)
    setDisabledCode(false)
    setDisabledSelling(false)
    setDisabledCost(false)
    setDisabledValidDays(false)
    setDisabledVoucherBook(false)
    setDisabledActive(false)
    setDisabledEditable(false)
    setDisabledRandomNo(false)
    SetDeleteEnable(true)
    setDisabledDesc(false)
    setDisabledCode(true)
    setSaveEnable(true)
  }

  //new button function
  const handleNew = e => {
    // e.preventDefault()
    ClearItem()
    setAlertShow(false)
    setSaveEnable(true)
  }

  //clear fields function
  const ClearItem = () => {
    SetCode("")
    SetDescription("")
    SetSellValue("0.0")
    SetPrintCostValue("0.0")
    SetValidDaysValue("1")
    SetNumberOfVouchersValue("1")
    SetBookNumberValue(0)
    SetActive(true)
    SetEditableStatus(false)
    SetRandomStatus(false)
    SetDeleteEnable(false)
    setDisabledCode(false)
    setDisabledCode(false)
    setDisabledSelling(false)
    setDisabledCost(false)
    setDisabledValidDays(false)
    setDisabledVoucherBook(false)
    setDisabledBookNo(false)
    setDisabledActive(false)
    setDisabledEditable(false)
    setDisabledRandomNo(false)
    setDisabledCode(false)
    setDisabledDesc(false)
    setAlertShow(false)
    setCrEnable(false)
    setReason("Created")
    setSearchdisabled(false)
  }


  const ValueSetter = async code => {

    if (code != "") {
      SetLoadingAlert(true)
      SetLoadingAlerttitle("Fetching...")
      let Data = await getVoucherGroupSearch(code)
      SetLoadingAlert(false)
      if (Data.length > 0) {
        Data.map(dr => {
          setSaveEnable(false)
          setCrEnable(true)
          setAddNew(false)
          SetDeleteEnable(true)
          SetCode(dr.strCode)
          SetDescription(dr.strName)
          SetActive(dr.strStatus)
          SetEditableStatus(dr.intEdit)
          SetRandomStatus(dr.intRand)
          SetSellValue(dr.dbValue)
          SetPrintCostValue(dr.dbCost)
          SetValidDaysValue(dr.dbExpairdate)
          SetNumberOfVouchersValue(dr.dbBookQty)
          SetBookNumberValue(dr.dbBookNo)
          setDisabledCode(true)
          setDisabledDesc(true)
          setDisabledSelling(true)
          setDisabledCost(true)
          setDisabledValidDays(true)
          setDisabledVoucherBook(true)
          setDisabledBookNo(true)
          setDisabledActive(true)
          setDisabledEditable(true)
          setDisabledRandomNo(true)
          setReason("Updated")
          setCrBy(dr.createdBy)
          setMdBy(dr.modifiedBy)
          setCrDate(dr.createdDate)
          setMdDate(dr.modifiedDate)
          setSearchdisabled(true)
        })
      } else {
        if (nullCode == false) {
          setDisabledCode(true)
          SetCode("")
          displayAlertMessage('success', "Record Not Found !")
        }
      }

    }
  }

  //modal props
  const columns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "code",
      text: "Code",
      sort: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "active",
      text: "Active",
      sort: true,
    },
    {
      dataField: "crby",
      text: "Created by",
      sort: true,
    },
    {
      dataField: "crdate",
      text: "Created on",
      sort: true,
    },
    {
      dataField: "mdby",
      text: "Last modified by",
      sort: true,
    },
    {
      dataField: "mddate",
      text: "Last modified date",
      sort: true,
    },
  ]

  //default sorted method
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const handleDelete = () => {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    const rowDelete = {
      "strMenuCode": menuCode,
      "strCode": strVoucherCode,
      "strLoggedCompany": LogCompanyCode,
      "strLoggedLocation": LocationCode,
      "strReason": strReason,
      "strCreateBy": crBy
    }

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Deleting...")

    fetch(`${ApiURL}Common/Delete`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
        body: JSON.stringify(rowDelete)
      }
    ).then(Response => {
      if (Response.status == "200") {
        SetLoadingAlert(false)
        Response.json()
          .then(responseData => {
            console.log(responseData)
            if (responseData.data == "Cannot Delete, Record Already Used!") {
              displayAlertMessage('warning', responseData.data)

            } else {
              ClearItem();
              displayAlertMessage('success', responseData.data)

            }
          }
          )
      } else if (Response.status == "400") {
        SetLoadingAlert(false)
        Response.json()
          .then(responseData => {
            setErrorMsg(responseData.msg)
          })
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Error !")

      } else {
        SetLoadingAlert(false)
        ClearItem()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }
  //*********Delete button function end */

  //CODE AUTO GEN
  const AutoGenerateCode = async () => {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL
    await fetch(`${ApiURL}common/autocode/${menuCode}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (responseData.data.length > 0) {
            SetCode(responseData.data)
          } else {
            setDisabledCode(false)
          }
        }
      })
  }

  //**Permission Check */
  const permission = (operation) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    const permissiondata = {
      "strUsername": permissionName,
      "strPassword": permissionPassword,
      "strLocation": LocationCode,
      "strMenuCode": menuCode
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {
            console.log(responseData.data)
            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")

                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")

                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")

              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "403") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "You have not Permission to make changes !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        clearPermissionInputs()

      } else {
        ClearItem()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }


  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
    console.log(response)
  }


  //Display Alert Function
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setAlertShow(true)

    setTimeout(() => {
      setAlertShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumb
            title={parentName}
            breadcrumbItem={menuName}
          ></Breadcrumb>
          <DPAlert
            confirm_both={sweetAlertShow}
            title={menuName}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              if (AlertConfirmOption == 1) {
                if (AddNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave()
                } else if (AddNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (AddNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave()
                } else if (AddNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                window.location.href = "/";
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 5) {

                if (AddNew == false && menuDelete == true && permissionReasonShow == false) {
                  handleDelete()
                } else if (AddNew == false && menuDelete == true && permissionReasonShow == true) {
                  setReason("")
                  handlePermissionAlert(LogUserType, "Deleted", true, true)

                } else {
                  setReason("")
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              }
            }}
            onCancel={() => {
              setsweetAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={strReason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 5) {
                permission("Delete")
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={!saveEnable}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={false}
                    printClick={() => {
                      alert("Print")
                    }}
                    //Delete Button
                    deleteEnable={deleteEnable}
                    deleteClick={() => {
                      setReason("Deleted")
                      setAlertDescription("Do you wish to delete ?");
                      setAlertConfirmOption(5)
                      setsweetAlertShow(true)
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <Row>
                    <VoucherGroupContent
                      AlertColor={AlertColor}
                      AlertMsg={AlertMsg}
                      show={AlertShow}
                      menuName={menuName}
                      CodeValue={strVoucherCode}
                      CodeonChange={e => {
                        let valCode = Text(
                          e.target,
                          3,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetCode(valCode)
                      }}
                      CodeonBlur={e => {
                        ValueSetter(e.target.value)
                      }}
                      disabledCode={disabledCode}
                      DescValue={strVoucherDesc}
                      DescOnChange={e => {
                        let valDesc = Text(
                          e.target,
                          60,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetDescription(valDesc)
                      }}
                      disabledDesc={disabledDesc}
                      ActiveonChange={() => {
                        SetActive(!IsActive)
                      }}
                      ActiveStatus={IsActive}
                      disabledActive={disabledDesc}
                      Gen_DataSearch={async () => {
                        tog_xlarge()
                      }}
                      SearchDataTables={DataTables}
                      SearchColumns={columns}
                      SearchDefaultSorted={defaultSorted}
                      SearchModelOpen={modal_xlarge}
                      SearchModelTrigger={tog_xlarge}
                      SearchGetSelectRow={GetSelectRow}
                      SellValue={dbSellValue}
                      SellOnChange={e => {
                        let valSell = Numeric(e.target, 8, 2, false)
                        if (valSell == "") {
                          SetSellValue("0.0")
                        } else {
                          SetSellValue(valSell)
                        }
                      }}
                      SellOnBlur={e => {
                        let valSell = DecimalValidation(e.target.value, 0, true, 2)
                        SetSellValue(valSell)
                      }}
                      disabledSelling={disabledSelling}
                      ValidDaysValue={dbValidDaysValue}
                      ValidDaysOnChange={e => {
                        let valValidDay = Numeric(e.target, 10, 0, false)
                        if (valValidDay == "") {
                          SetValidDaysValue("1")
                        } else {
                          SetValidDaysValue(valValidDay)
                        }
                      }}
                      ValidDaysOnOnBlur={e => {
                        let valValidDay = Numeric(e.target, 10, 0, false)
                        if (valValidDay == "") {
                          SetValidDaysValue("1")
                        } else {
                          SetValidDaysValue(parseFloat(e.target.value, 10))
                        }
                      }}

                      disabledValidDays={disabledValidDays}
                      PrintCostValue={dbPrintCostValue}
                      PrintCostOnChange={e => {
                        let valCost = Numeric(e.target, 8, 2, false)
                        if (valCost == "") {
                          SetPrintCostValue("0.0")
                        } else {
                          SetPrintCostValue(valCost)
                        }
                      }}
                      PrintCostOnOnBlur={e => {
                        let valCost = DecimalValidation(e.target.value, 0, true, 2)
                        SetPrintCostValue(valCost)
                      }}

                      disabledCost={disabledCost}
                      NumberOfVouchersValue={dbNumberOfVouchersValue}
                      NumberOfVouchersOnChange={e => {
                        let valNumberOfVoucher = Numeric(e.target, 10, 0, false)

                        if (valNumberOfVoucher == "") {
                          SetNumberOfVouchersValue("1")
                        } else {
                          if (valNumberOfVoucher > 0) {
                            SetNumberOfVouchersValue(valNumberOfVoucher)
                          } else {
                            SetNumberOfVouchersValue("1")
                          }
                        }
                      }}
                      NumberOfVouchersOnBlur={e => {
                        let valNumberOfVoucher = Numeric(e.target, 10, 0, false)
                        if (valNumberOfVoucher == "") {
                          SetNumberOfVouchersValue("1")
                        } else {
                          if (valNumberOfVoucher > 0) {
                            SetNumberOfVouchersValue(
                              parseFloat(e.target.value, 10)
                            )
                          } else {
                            SetNumberOfVouchersValue("1")
                          }
                        }
                      }}

                      disabledVoucherBook={disabledVoucherBook}
                      BookNumberValue={dbBookNumberValue}
                      BookNumberOnChange={e => {
                        let valBookNumber = Numeric(e.target, 10, 0, false)
                        if (valBookNumber == "") {
                          SetBookNumberValue(0)
                        } else {
                          SetBookNumberValue(valBookNumber)
                        }
                      }}

                      BookNumberOnBlur={e => {
                        let valBookNumber = Numeric(e.target, 10, 0, false)
                        if (valBookNumber == "") {
                          SetBookNumberValue(0)
                        } else {
                          SetBookNumberValue(parseFloat(e.target.value, 10))
                        }
                      }}
                      disabledBookNo={disabledBookNo}
                      EditableChange={() => {
                        SetEditableStatus(!blEditableStatus)
                      }}
                      EditableStatus={blEditableStatus}
                      disabledEditable={disabledEditable}
                      RandomonChange={() => {
                        SetRandomStatus(!blRandomStatus)
                      }}
                      RandomStatus={blRandomStatus}
                      disabledRandomNo={disabledRandomNo}
                      onButtonClick={e => {
                        AutoGenerateCode()
                        setCodeButton(true)
                      }}
                      btnDisable={codeButton}
                      SearchDisable={searchdisabled}
                      menuCode={menuCode}
                      autoCode={autoCode}

                    />
                  </Row>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default VoucherGroup
